import { useEffect } from "react";

import Grid from "@mui/material/Grid";
import Autocomplete from "@mui/material/Autocomplete";

import FormField from "../../../layouts/ecommerce/products/new-product/components/FormField";
import TextField from "@mui/material/TextField";
import Stack from "@mui/material/Stack";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { fr } from "date-fns/locale";
import moment from "moment";

// Material Dashboard 2 PRO React components
import MDInput from "../../../components/MDInput";
import MDBox from "../../../components/MDBox";

import { useSelector, useDispatch } from "react-redux";

import { getUsers } from "api/users";

import { setAllUsers } from "redux/reducers/usersReducer";

export default function OrderCommentaries({
  commentaryUserId,
  setCommentaryUserId,
  commentaryDate,
  setCommentaryDate,
  commentaryAction,
  setCommentaryAction,
}) {
  const dispatch = useDispatch();
  const allUsers = useSelector((state) => state.users.allUsers);

  async function fetchUsers() {
    const response = await getUsers();
    const formatedUsers = await response.data.map((user) => ({
      label: user.name,
      id: user.user_id,
    }));
    dispatch(setAllUsers(formatedUsers));
  }

  useEffect(() => {
    fetchUsers();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const dateNow = new Date(); // Creating a new date object with the current date and time
  const year = dateNow.getFullYear(); // Getting current year from the created Date object
  const monthWithOffset = dateNow.getUTCMonth() + 1; // January is 0 by default in JS. Offsetting +1 to fix date for calendar.
  const month = // Setting current Month number from current Date object
    monthWithOffset.toString().length < 2 // Checking if month is < 10 and pre-prending 0 if not to adjust for date input.
      ? `0${monthWithOffset}`
      : monthWithOffset;
  const date =
    dateNow.getUTCDate().toString().length < 2 // Checking if date is < 10 and pre-prending 0 if not to adjust for date input.
      ? `0${dateNow.getUTCDate()}`
      : dateNow.getUTCDate();

  const materialDateInput = `${year}-${month}-${date}`; // combining to format for defaultValue or value attribute of material <TextField>

  return (
    <MDBox>
      <Grid container spacing={2}>
        <Grid item xs={6}>
          <Autocomplete
            options={allUsers}
            value={commentaryUserId}
            required
            onChange={(event, newcommentaryUserId) => {
              setCommentaryUserId(newcommentaryUserId);
            }}
            renderInput={(params) => <MDInput {...params} label="Nom" variant="standard" />}
          />
        </Grid>
        <Grid item xs={6}>
          <Stack component="form" noValidate>
            <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={fr}>
              <DatePicker
                slotProps={{ field: { clearable: true } }}
                displayWeekNumber
                label="Choisissez la date"
                value={commentaryDate && new Date(commentaryDate)}
                onChange={(newValue) => {
                  if (newValue === null) {
                    setCommentaryDate(null);
                  } else setCommentaryDate(moment(newValue).format("YYYY-MM-DD"));
                }}
                renderInput={(params) => <TextField {...params} fullWidth />}
                format="dd/MM/yyyy"
              />
            </LocalizationProvider>
          </Stack>
        </Grid>
        <Grid item xs={12}>
          <FormField
            multiline
            minRows={2}
            value={commentaryAction}
            onChange={(event) => setCommentaryAction(event.target.value)}
            required
            variant="outlined"
            type="text"
            label="Commentaire"
          />
        </Grid>
      </Grid>
    </MDBox>
  );
}
